import styled from 'styled-components';
import Typography from '../typography/Typography';
import { quilBox } from './quill';
export const BlogArticleContentContainer = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;

  ${({ theme }) => theme.media.tablet `
  margin-left: 6rem;`}
`;
export const BlogArticleContentHeader = styled.header `
  display: flex;
  flex-direction: column;
  padding-top: 4rem;
  gap: 2rem;
  width: 100%;
`;
export const BlogArticleHeadline = styled(Typography) `
  word-break: break-word;
`;
export const SocialNetworksAndCreateDate = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20rem;
  margin-bottom: 3.6rem;
  height: 4rem;

  ${({ theme }) => theme.media.laptop `
  margin-bottom: 4rem;

  `}
`;
export const BlogArticleTimeWrapper = styled.div `
  display: flex;
  gap: 3.2rem;
  width: 100%;
  justify-content: space-between;
  ${({ theme }) => theme.media.tablet `
  justify-content:unset;
  `}
`;
export const BlogArticleMainContent = styled(quilBox) `
  width: 100%;
  word-break: break-all;
  img {
    max-width: 100%;
  }
`;
//# sourceMappingURL=styles.js.map